;(() => {
  if (customElements.get('rich-text-dropdown')) return

  class RichTextDropdown extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.setProperties()
      this.setEventListeners()
    }

    disconectedCallback() {
      this.removeEventListeners()
    }

    setProperties() {
      this.btn = this.querySelector('[data-btn]')
      this.content = this.querySelector('[data-content]')
    }

    setEventListeners() {
      this.onClickHandler = this.toggle.bind(this)
      this.btn?.addEventListener('click', this.onClickHandler)
    }

    removeEventListeners() {
      this.btn?.removeEventListener('click', this.onClickHandler)
    }

    toggle() {
      if (this.animating) return
      this.animating = true

      this.btn.classList.toggle('open')

      const isOpen = this.btn.classList.contains('open')
      const contentHeight = this.content.scrollHeight

      const animation = this.content.animate(
        [{ height: `${isOpen ? 0 : contentHeight}px` }, { height: `${isOpen ? contentHeight : 0}px` }],
        { duration: 400, easing: 'ease-in-out' }
      )

      animation.onfinish = () => {
        this.content.style.height = isOpen ? 'auto' : '0'
        this.animating = false
      }
    }
  }

  customElements.define('rich-text-dropdown', RichTextDropdown)
})()
